var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('new-app-header'),_c('new-app-carousel'),_c('app-notice'),_c('app-content'),_c('new-app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }